export const breakpoint_sm ="480px";
export const breakpoint_md = "768px";
export const breakpoint_lg = "992px";
export const breakpoint_xl = "1024px";
export const breakpoint_xxl = "1440px";